'use client';

import { useState } from 'react';

export function SiteThumb({ src }: { src?: string }) {
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <div className="h-[60px] w-[102px] shrink-0 overflow-hidden rounded">
      {src && !failed ? (
        <img
          data-hook="site-thumb"
          src={src}
          alt=""
          className={`h-full w-full object-cover ${ready ? '' : 'invisible'}`}
          onLoad={() => setReady(true)}
          onError={() => setFailed(true)}
        />
      ) : null}
    </div>
  );
}
